import LeftDecoration from 'src/common/assets/left-decoration.svg';
import RightDecoration from 'src/common/assets/right-decoration.svg';
import styled from 'styled-components';

import { media } from '~/src/styles-constants';

export const TitleContainer = styled.div`
  display: flex;
  gap: 4px;

  h2 {
    background-color: ${({ theme }) => theme.palette.common.PINK};
    padding: 16px;
    border-radius: 40px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.common.PITAYA};
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-weight: 700;
    font-size: 16px;
    line-height: normal;
    ${media.M`
      font-size: 24px;
      line-height: 40px
  `}
  }
`;

export const LeftTitleDecoration = styled(LeftDecoration)`
  align-self: center;
`;
export const RightTitleDecoration = styled(RightDecoration)`
  align-self: flex-start;
`;
